// extracted by mini-css-extract-plugin
export var fakeLink = "search-card-module--fakeLink--jmjca";
export var imageContainer = "search-card-module--imageContainer--fzFPt";
export var productCardStyle = "search-card-module--productCardStyle--ohXPY";
export var productDetailsStyle = "search-card-module--productDetailsStyle--jKPa4";
export var productHeadingStyle = "search-card-module--productHeadingStyle--enMMt";
export var productPrice = "search-card-module--productPrice--JPk2A";
export var productSubtitleStyle = "search-card-module--productSubtitleStyle--nH6eu";